import {
  CheckScheduleConflictQuery,
  ScheduleClient,
} from "../../web-api-client";
import { ScheduleConflictFormValues } from "../../types/ScheduleConflictFormValues";
import { useQuery } from "@tanstack/react-query";

import { makeFetchWithAuth } from "../../auth/authFetch";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { useNavigate } from "react-router-dom";
import { appConfig } from "../../appconfig";

type ConflictCheckResult = string[]; // backend Ok<List<string>>

export const useScheduleConflictCheck = (
  values: ScheduleConflictFormValues
) => {
  const navigate = useNavigate();

  const api = new ScheduleClient(appConfig.apiBaseUrl, {
    fetch: makeFetchWithAuth(fetchWithTimeout(), {
      onUnauthorized: () =>
        navigate("/login", {
          replace: true,
          state: { from: window.location.pathname },
        }),
    }),
  });

  const { clinicExtId, doctorExtId, dates = [], startTime, endTime } = values;

  const enabled =
    !!clinicExtId &&
    !!doctorExtId &&
    dates.length > 0 &&
    !!startTime &&
    !!endTime;

  return useQuery<ConflictCheckResult, Error>({
    queryKey: [
      "check-schedule-conflicts",
      clinicExtId,
      doctorExtId,
      dates,
      startTime,
      endTime,
    ],
    enabled,
    queryFn: async () => {
      const query = new CheckScheduleConflictQuery({
        clinicExtId: clinicExtId!,
        doctorExtId: doctorExtId!,
        dates,
        startTime: startTime!,
        endTime: endTime!,
      });

      const result = await api.checkScheduleConflict(query);

      return result ?? [];
    },
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
};
